import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { projectService } from "../services/project.service";

export const createProject = createAsyncThunk("createProject", async (data, { rejectWithValue }) => {
    try {
        return await projectService.createProject(data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const getProjectList = createAsyncThunk("getProjectList", async (params, { rejectWithValue }) => {
    try {
        //if status =="", then remove it
        if(params.status === ""){
            delete params.status;
        }
        return await projectService.getProjectList(params);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const getProject = createAsyncThunk("getProject", async (id, { rejectWithValue }) => {
    try {
        return await projectService.getProject(id);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const updateProject = createAsyncThunk("updateProject", async ({data,id}, { rejectWithValue }) => {
    try {
        return await projectService.updateProject(id, data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const deleteProject = createAsyncThunk("deleteProject", async (id, { rejectWithValue }) => {
    try {
        return await projectService.deleteProject(id);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const updateProjectStatus = createAsyncThunk("updateProjectStatus", async (data, { rejectWithValue }) => {
    try {
        return await projectService.updateProjectStatus(data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

const projectSlice = createSlice({
    name: "pmo-project",
    initialState: {
        list: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        detail: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        create: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        update: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        delete: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        status: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        }
    },
    reducers: {
        resetStateProject: (state) => {
            state.list.isError = false;
			state.list.message = null;
			state.detail.isError = false;
			state.detail.message = null;
			state.create.isError = false;
			state.create.message = null;
			state.create.data = null;
			state.update.isError = false;
			state.update.message = null;
			state.update.data = null;
			state.delete.isError = false;
			state.delete.message = null;
			state.delete.data = null;
			state.status.isError = false;
			state.status.message = null;
			state.status.data = null;

        },
    },
    extraReducers: (builder) => {
        // get project list
        builder.addCase(getProjectList.pending, (state) => {
            state.list.isLoading = true;
        });
        builder.addCase(getProjectList.fulfilled, (state, action) => {
            state.list.isLoading = false;
            state.list.data = action.payload;
            state.list.isError = false;
        });
        builder.addCase(getProjectList.rejected, (state, action) => {
            state.list.isLoading = false;
            state.list.isError = true;
            state.list.message = action.payload?.message;
        });

        // get project detail
        builder.addCase(getProject.pending, (state) => {
            state.detail.isLoading = true;
        });
        builder.addCase(getProject.fulfilled, (state, action) => {
            state.detail.isLoading = false;
            state.detail.data = action.payload;
            state.detail.isError = false;
        });
        builder.addCase(getProject.rejected, (state, action) => {
            state.detail.isLoading = false;
            state.detail.isError = true;
            state.detail.message = action.payload?.message;
        });

        // create project
        builder.addCase(createProject.pending, (state) => {
            state.create.isLoading = true;
        });
        builder.addCase(createProject.fulfilled, (state, action) => {
            state.create.isLoading = false;
            state.create.data = action.payload;
            state.create.isError = false;
        });
        builder.addCase(createProject.rejected, (state, action) => {
            state.create.isLoading = false;
            state.create.isError = true;
            state.create.message = action.payload?.message;
        });

        // update project
        builder.addCase(updateProject.pending, (state) => {
            state.update.isLoading = true;
        });
        builder.addCase(updateProject.fulfilled, (state, action) => {
            state.update.isLoading = false;
            state.update.data = action.payload;
            state.update.isError = false;
        });
        builder.addCase(updateProject.rejected, (state, action) => {
            state.update.isLoading = false;
            state.update.isError = true;
            state.update.message = action.payload?.message;
        });

        // delete project
        builder.addCase(deleteProject.pending, (state) => {
            state.delete.isLoading = true;
        });
        builder.addCase(deleteProject.fulfilled, (state, action) => {
            state.delete.isLoading = false;
            state.delete.data = action.payload;
            state.delete.isError = false;
        });
        builder.addCase(deleteProject.rejected, (state, action) => {
            state.delete.isLoading = false;
            state.delete.isError = true;
            state.delete.message = action.payload?.message;
        });

        // update project status
        builder.addCase(updateProjectStatus.pending, (state) => {
            state.status.isLoading = true;
        });
        builder.addCase(updateProjectStatus.fulfilled, (state, action) => {
            state.status.isLoading = false;
            state.status.data = action.payload;
            state.status.isError = false;
        });
        builder.addCase(updateProjectStatus.rejected, (state, action) => {
            state.status.isLoading = false;
            state.status.isError = true;
            state.status.message = action.payload?.message;
        });
    },
});

export default projectSlice.reducer;
export const { resetStateProject } = projectSlice.actions;